<template>
    <v-autocomplete
        dense
        outlined
        v-model="select"
        @input="handleInput"
        :items="items"
        :search-input.sync="search"
        :item-text="displayName"
        return-object
        clearable
        no-filter
        flat
        hide-no-data
        hide-details
        :readonly="readonly"
        :clearable="!readonly"
        :label="label || $t('Nosology')"
    ></v-autocomplete>
</template>

<script>
import nosologyService from '@/service/nosology-service';

export default {
    props: {
        value: String,
        label: String,
        preventPriceCheck: Boolean,
        parentCode: Number,
        parentSalary: Boolean,
        type: String,
		typeAnyStartsWith: String,
        filterPersonSalary: Number,
        readonly: Boolean,
    },
    data() {
        return {
            items: [],
            search: null,
            select: null,
            timer: null,
            getDataAbort: null,
        }
    },
    mounted() {
        if (this.value) {
            this.setSelected(this.value);
        }
    },
    watch: {
        search(value, oldValue) {
            if (value !== oldValue) {
                if (
                    value !== (this.select && this.select.kod) &&
                    value !== this.displayName(this.select)
                ) {
                    clearTimeout(this.timer);
                    this.items = [];
                    if (this.getDataAbort) {
                        this.getDataAbort.abort();
                    }
                    if (value) {
                        this.timer = setTimeout(
                            () => this.querySelections(value),
                            300
                        );
                    }
                }
            }
        },
        value(val) {
            if (!val) {
                this.search = null;
                this.select = null;
                this.items = [];
            } else {
                this.setSelected(val);
            }
        },
    },
    methods: {
        async filterParentCode() {
            return this.parentSalary
                ? await nosologyService.constant.parentCode.salary()
                : this.parentCode > 0
                ? this.parentCode
                : null;
        },
        async hasParentFilter() {
            return this.parentSalary ? true : this.parentCode > 0 ? true : null;
        },
        async getData(filter, callback) {
            if (
                (await this.hasParentFilter()) &&
                !(await this.filterParentCode())
            ) {
                return;
            }
            if (this.getDataAbort) {
                this.getDataAbort.abort();
                this.items = [];
            }
            this.getDataAbort = new AbortController();
            nosologyService
                .getData(
                    1,
                    20,
                    {
                        ...filter,
                        parent_code: await this.filterParentCode(),
                        prevent_price_check: this.preventPriceCheck,
                        type: this.type,
                        type_any_starts_with: this.typeAnyStartsWith,
                        filter_person_salary: this.filterPersonSalary,
                    },
                    this.getDataAbort && this.getDataAbort.signal
                )
                .then((response) => callback(response))
                .finally(() => {
                    this.getDataAbort = null;
                });
        },
        querySelections(search) {
            this.getData(
                { search },
                (response) => (this.items = response.data)
            );
        },
        handleInput() {
            this.$emit('input', this.select && this.select.kod);
        },
        setSelected(value) {
            if (value && (!this.select || !this.select.kod || value !== this.select)) {
                this.getData({ kod: value }, (response) => {
                    var data = response.data.filter((d) => d.kod == value);
                    if (data.length > 0) {
                        this.items = data;
                        this.select = data[0];
                    }
                });
            }
        },
        displayName(item) {
            if (item) {
                return `[${item.kod}] ${item.name || ''}`;
            }
            return null;
        },
    },
};
</script>

<style>
</style>